"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCanonizedDiaIDs = void 0;
const makeRacemic_js_1 = require("../util/makeRacemic.js");
const tagAtom_1 = require("../util/tagAtom");
function getCanonizedDiaIDs(diaMol) {
    const heterotopicSymmetryRanks = diaMol.heterotopicSymmetryRanks;
    const moleculeWithH = diaMol.moleculeWithH;
    const finalRanks = diaMol.finalRanks;
    const canonizedDiaIDs = new Array(moleculeWithH.getAllAtoms());
    moleculeWithH.ensureHelperArrays(
    //@ts-expect-error TODO
    diaMol.Molecule.cHelperSymmetryStereoHeterotopicity);
    const cache = {};
    for (let i = 0; i < diaMol.moleculeWithH.getAllAtoms(); i++) {
        const rank = heterotopicSymmetryRanks[i];
        if (rank && cache[rank]) {
            canonizedDiaIDs[finalRanks[i]] = cache[rank].diaID;
            continue;
        }
        const tempMolecule = diaMol.moleculeWithH.getCompactCopy();
        (0, tagAtom_1.tagAtom)(tempMolecule, i);
        (0, makeRacemic_js_1.makeRacemic)(tempMolecule);
        const diaID = tempMolecule.getCanonizedIDCode(
        //@ts-expect-error TODO
        diaMol.Molecule.CANONIZER_ENCODE_ATOM_CUSTOM_LABELS);
        canonizedDiaIDs[finalRanks[i]] = diaID;
    }
    return canonizedDiaIDs;
}
exports.getCanonizedDiaIDs = getCanonizedDiaIDs;
//# sourceMappingURL=getCanonizedDiaIDs.js.map